/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  getViewingText.ts
 */

import type { Viewing } from '@zcode/bizos'
import { ViewingType } from '@zcode/enums'
import { formatInTimeZone } from 'date-fns-tz'

export const getViewingText = (
  viewings: readonly Viewing[] | null | undefined,
  tz: string | null
) => {
  if (!viewings?.length) {
    return null
  }
  const viewing = viewings[0]
  const { beginOn, viewingType } = viewing
  if (viewingType === ViewingType.OPEN_HOUSE) {
    const viewingDate = new Date(beginOn * 1000)
    return `Open ${formatInTimeZone(viewingDate, tz ?? 'America/Chicago', 'EEE, M/d')}`
  }
  return null
}
